/** Support → find a client (CRM contact) or an Academy learner, then open their support record. */

import { useSupportCustomersList, useSupportLearnersList } from "@agencyos/api-client";
import { GlassCard, Skeleton, TextField } from "@agencyos/ui-web";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function Results({ kind, q }: { kind: "customers" | "learners"; q: string }) {
  const { t } = useTranslation();
  const customers = useSupportCustomersList({ q }, { query: { enabled: kind === "customers" && q.length >= 2 } });
  const learners = useSupportLearnersList({ q }, { query: { enabled: kind === "learners" && q.length >= 2 } });
  const query = kind === "customers" ? customers : learners;
  if (q.length < 2) return null;
  if (query.isPending) return <Skeleton style={{ height: 80 }} />;
  const rows = query.data?.status === 200 ? query.data.data.results : [];
  if (!rows.length) return <p className="muted">{t("support.card.none")}</p>;
  return (
    <ul className="plain-list stack">
      {rows.map((row) => (
        <li key={row.id}>
          <Link to={`/support/${kind === "customers" ? "customers" : "learners"}/${row.id}`}>{row.name || row.email || row.phone}</Link>{" "}
          <small className="muted">
            {row.email} {row.phone}
          </small>
        </li>
      ))}
    </ul>
  );
}

export function CustomerSearch() {
  const { t } = useTranslation();
  const [q, setQ] = useState("");
  const term = q.trim();
  return (
    <GlassCard as="section" className="stack" aria-labelledby="support-search-title">
      <h2 id="support-search-title">{t("support.card.search")}</h2>
      <TextField type="search" label={t("support.card.searchHint")} value={q} onChange={(e) => setQ(e.target.value)} />
      <div className="grid-2">
        <section className="stack" aria-labelledby="support-search-learners">
          <h3 id="support-search-learners">{t("support.card.learners")}</h3>
          <Results kind="learners" q={term} />
        </section>
        <section className="stack" aria-labelledby="support-search-clients">
          <h3 id="support-search-clients">{t("support.card.clients")}</h3>
          <Results kind="customers" q={term} />
        </section>
      </div>
    </GlassCard>
  );
}
